import { XCircleIcon } from "@heroicons/react/20/solid";
import { lazy, Suspense } from 'react';

import { useAppDispatch } from "../../../store";
import { uiActions } from "../../ui/slice";
import { Button } from "../../ui/components/Button";
import { Modal } from '../../ui/components/Modal';

const Settings = lazy(() => import('./Settings').then(module => ({ default: module.Settings })));

export const SettingsDialog = () => {

  const dispatch = useAppDispatch();
  const closeModal = () => dispatch(uiActions.setCurrentModal(null));

  return (
    <Modal
      height={90}
      hide={closeModal}
      modalKey='settingsDialog'
      width={80}
    >
      <button
        className='absolute right-2 top-2 size-8 z-50 text-white'
        onClick={closeModal}
      >
        <XCircleIcon />
      </button>
      <Suspense>
        <Settings />
      </Suspense>
      <div className='w-full flex justify-end mt-4'>
        <Button
          grow={false}
          onClick={closeModal}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};
